module.exports = __webpack_public_path__ + "static/media/the_dog_house_megaways.pragmaticplay.f4de5f05.jpeg";